// extracted by mini-css-extract-plugin
module.exports = {"root":"SendMessage_root_1AbRn","input":"SendMessage_input_3vO1t","icon":"SendMessage_icon_27bLT","loading":"SendMessage_loading_Syt8U","blinker":"SendMessage_blinker_3Slpu"};